import { StoreFontEnum as e } from "../enums/store-font-enum.mjs";
import { StoreThemeEnum as r } from "../enums/store-theme-enum.mjs";
const o = {
  primaryFont: e.Inter,
  secondaryFont: e.Inter
}, t = {
  [r.default]: {
    theme: r.default,
    primaryColor: "#00A0FF",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F1F4F8",
    ...o
  },
  [r.luminous]: {
    theme: r.luminous,
    primaryColor: "#6620FA",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F8F5FF",
    ...o
  },
  [r.night]: {
    theme: r.night,
    primaryColor: "#FC3C67",
    secondaryColor: "#0A1733",
    tertiaryColor: "#142D63",
    ...o
  },
  [r.camilla]: {
    theme: r.camilla,
    primaryColor: "#EEFF34",
    secondaryColor: "#121212",
    tertiaryColor: "#121212",
    ...o
  },
  [r.creamy]: {
    theme: r.creamy,
    primaryColor: "#E40160",
    secondaryColor: "#FCF1E3",
    tertiaryColor: "#FFFAF4",
    ...o
  },
  [r.sepia]: {
    theme: r.sepia,
    primaryColor: "#E7961B",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#FFF7EB",
    ...o
  },
  [r.solarized]: {
    theme: r.solarized,
    primaryColor: "#00A0FF",
    secondaryColor: "#011420",
    tertiaryColor: "#011420",
    ...o
  },
  [r.new_york]: {
    theme: r.new_york,
    primaryColor: "#FFC634",
    secondaryColor: "#01133A",
    tertiaryColor: "#01133A",
    ...o
  },
  [r.urban]: {
    theme: r.urban,
    primaryColor: "#F57F29",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...o
  },
  [r.cyberpunk]: {
    theme: r.cyberpunk,
    primaryColor: "#AE3ECA",
    secondaryColor: "#131114",
    tertiaryColor: "#1e1533",
    ...o
  },
  [r.cosmopolitan]: {
    theme: r.cosmopolitan,
    primaryColor: "#D9335a",
    secondaryColor: "#FFFFFF",
    tertiaryColor: "#F9F9F9",
    ...o
  }
};
export {
  t as defaultDesignValues,
  o as defaultFontValues
};
